(function Module() {
	'use strict';
	const {_,moment} = require('../globals');

    angular.module('mySynch').component('ng1App',{
        template: `<ng-include src="'../partials/app/ng1.app.view.html'"></ng-include>`,
        bindings: {

        },
        controller: [ '$scope','MySynchFactory','$window','deviceDetector', function($scope,MSF,$window,deviceDetector){
            $scope.MSF = MSF;
            $scope._ = _;
            $scope.moment = moment;
            $scope.isMobile = deviceDetector.isMobile();
            $scope.noHeaderPages = ["Login","Welcome","WelcomeToFarm","ForgotPassword","PasswordReset"];
            $scope.bodyContentLoading = true;
            $scope.siteBodyMT =  $('#site-header-content').outerHeight() +'px'; // '72px';

            $scope.siteBodyContentDiv = undefined;
            var deregSiteBodyContentDivWatch  = undefined;

            $scope.waitForElmInProgress = false;

            $scope.getBodyContentMarginTop = function getBodyContentMarginTop (){
                var siteHeader = $('#site-header-content');
                return siteHeader.outerHeight() +'px';
            }

            var deregWindowEvent = undefined;
           

           
            
			$scope.setPageOuterContainerWidth = function setPageOuterContainerWidth(){
				
				var htmlRoot = $("html");
                var siteNav = $(".sidebar-nav");
                var pageOuterContJObj = $(".page-outer-container");
                var pageOuterContElm = pageOuterContJObj.get(0);

                    if($scope.isMobile){
                        pageOuterContJObj.css({"width":htmlRoot.outerWidth(true)+"px"})
                    }else{
                        pageOuterContJObj.css({"width":htmlRoot.outerWidth(true) - siteNav.outerWidth(true)+"px"})
                    }
          
                			
            }
		
			

            $scope.$on("$destroy", function() {
			
                 angular.element($window).unbind('resize',function(){});
            });

            MSF.ready(function onMsfReady() {
               var pageOuterContJObj = $(".page-outer-container");
               var pageOuterContElm = pageOuterContJObj.get(0);

              if(_.isUndefined(pageOuterContElm) && !$scope.waitForElmInProgress){
                    console.log(" MSF.ready: pageOuterContElm was undefined starting wait ")
                    $scope.waitForElmInProgress = true;
                    MSF.waitForElm(".page-outer-container").then(function (elm){
                        console.log(" MSF.ready: pageOuterContElm found! setting width ")
                            $scope.waitForElmInProgress = false;
                            $scope.setPageOuterContainerWidth();
                        })
              }else{
                $scope.setPageOuterContainerWidth();
              }
               
             
            });

            
            angular.element($window).bind('resize', function () {
                var pageOuterContJObj = $(".page-outer-container");
                var pageOuterContElm = pageOuterContJObj.get(0);
                if(_.isUndefined(pageOuterContElm) && !$scope.waitForElmInProgress){
                    $scope.waitForElmInProgress = true;
                    console.log(" angular.element: pageOuterContElm was undefined starting wait ")
                    MSF.waitForElm(".page-outer-container").then(function (elm){
                        console.log(" angular.element: pageOuterContElm found! setting width ")
                       $scope.waitForElmInProgress = false;
                       $scope.setPageOuterContainerWidth();
                   })
                }else{
                    $scope.setPageOuterContainerWidth();
                }
            });

          
        }],
    });


})();